/**
 * Табы портфолио.
 *
 * При клике на таб:
 *   - снимаем is--active со всех табов, ставим на текущий
 *   - скрываем все панели, показываем соответствующую
 *
 * Работает через data-атрибуты, никаких id в разметке.
 */
export function initPortfolioTabs() {
  const tabs = document.querySelectorAll(".portfolio__tab[data-tab]");
  const panels = document.querySelectorAll(".portfolio__panel[data-panel]");
  if (!tabs.length || !panels.length) return;

  function activate(tabId) {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === tabId;
      tab.classList.toggle("is--active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.panel === tabId;
      panel.hidden = !isActive;
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      activate(tab.dataset.tab);
    });
  });
}
